import Vue from 'vue'
import App from './App.vue'
import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css';
import firebase from 'firebase/app';
import 'firebase/auth';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import axios  from 'axios';

Vue.config.productionTip = false

Vue.use(SuiVue);
Vue.use(Datetime);

if (process.env.VUE_APP_FIREBASE_CONFIG) {
  firebase.initializeApp(JSON.parse(atob(process.env.VUE_APP_FIREBASE_CONFIG)));
} else {
  console.error(`VUE_APP_FIREBASE_CONFIG is not defined`);
}

const updateAuthState = () => {
  return new Promise((resolve) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(function(user) {
      resolve(user);
      if (user) {
        console.log(`User is signed in`, user);
      } else {
        console.log(`No user is signed in`);
      }
      unsubscribe();
    });
  });
};


(async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const access_token = urlParams.get('token');
  urlParams.delete('token');
  // window.history.pushState({}, null, )
  await updateAuthState();
  if (!firebase.auth().currentUser && access_token) {
    const { data: logInResponse } = await axios.get(`${process.env.VUE_APP_EZCHANNEL_BASE_URL}/auth/login`, {
      params: {
        token: access_token,
        type: 'sso',
      },
    });
    const { token: channelToken } = logInResponse;
    const { projectId } = firebase.app().options;

    const { data: { customToken, username, uid } } = await axios.get(`https://us-central1-${projectId}.cloudfunctions.net/exchangeToken`, {
      params: {
        token: channelToken,
        baseUrl: process.env.VUE_APP_EXCHANGE_TOKEN_BASE_URL,
      },
    });
    username, uid;
    await firebase.auth().signInWithCustomToken(customToken);
    window.location.search = urlParams.toString();
  }
  
  const [
    { default: router },
    { default: store },
  ] = await Promise.all([
    import('./router'),
    import('./store'),
  ]);
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');

})();
